module.exports = __webpack_public_path__ + "media/proksee-viewer/images/sidebar-close-6647bb9aa79e37ef4ff8a2dc9b77234e.png";